'use strict';
import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  fullWidthHeight: {
    width: '100%',
    height: '100%',
  },
  fullScreenWrap: {
    width: '100%',
    height: '100%',
    flexWrap: 'wrap',
  },
  fullHeight: {
    height: '100%',
  },
  fullHeightRelative: {
    height: '100%',
    position: 'relative',
  },
  width90Height90: {
    width: '90%',
    height: '90%',
  },
  twoThirdWidth: {
    width: '66.66%',
  },
  oneThirdWidth: {
    width: '33.33%',
  },
  threeForthWidth: {
    width: '75%',
  },
  oneForthWidth: {
    width: '25%',
  },
  absoluteFullWidthFullHeight: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  darkGrey: {
    color: colors.darkGrey,
  },
  zIndex2: {
    zIndex: 2,
  },
  zIndex9999: {
    zIndex: 9999,
  },
  exercisesetCard: {
    backgroundColor: colors.white,
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  greyBackground: {
    backgroundColor: '#edeced',
  },
  alignCenter: { alignItems: 'center' },
});
